// import AuthActions from '../Redux/AuthRedux'
// import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import InsuranceActions from '../Redux/InsuranceRedux'
import { getToken } from '../Services/GetToken'

export function * getTravelPackage (api, action) {
  yield baseFetchToken(
    api.getTravelPackage,
    action.data,
    getToken,
    InsuranceActions.getTravelPackageSuccess,
    InsuranceActions.getTravelPackageFailure
  )
}

export function * postTravelPackage (api, action) {
  yield baseFetchToken(
    api.postTravelPackage,
    action.data,
    getToken,
    InsuranceActions.postTravelPackageSuccess,
    InsuranceActions.postTravelPackageFailure
  )
}

export function * putTravelPackage (api, action) {
  yield baseFetchToken(
    api.putTravelPackage,
    action.data,
    getToken,
    InsuranceActions.putTravelPackageSuccess,
    InsuranceActions.putTravelPackageFailure
  )
}

export function * deleteTravelPackage (api, action) {
  yield baseFetchToken(
    api.deleteTravelPackage,
    action.data,
    getToken,
    InsuranceActions.deleteTravelPackageSuccess,
    InsuranceActions.deleteTravelPackageFailure
  )
}

export function * viewTravelPackage (api, action) {
  yield baseFetchToken(
    api.viewTravelPackage,
    action.data,
    getToken,
    InsuranceActions.viewTravelPackageSuccess,
    InsuranceActions.viewTravelPackageFailure
  )
}

export function * postTravelPackagePrice (api, action) {
  yield baseFetchToken(
    api.postTravelPackagePrice,
    action.data,
    getToken,
    InsuranceActions.postTravelPackagePriceSuccess,
    InsuranceActions.postTravelPackagePriceFailure
  )
}

export function * putTravelPackagePrice (api, action) {
  yield baseFetchToken(
    api.putTravelPackagePrice,
    action.data,
    getToken,
    InsuranceActions.putTravelPackagePriceSuccess,
    InsuranceActions.putTravelPackagePriceFailure
  )
}

export function * switchTravelPackagePrice (api, action) {
  yield baseFetchToken(
    api.switchTravelPackagePrice,
    action.data,
    getToken,
    InsuranceActions.switchTravelPackagePriceSuccess,
    InsuranceActions.switchTravelPackagePriceFailure
  )
}

export function * getTicketPackage (api, action) {
  yield baseFetchToken(
    api.getTicketPackage,
    action.data,
    getToken,
    InsuranceActions.getTicketPackageSuccess,
    InsuranceActions.getTravelPackageFailure
  )
}

export function * postTicketPackage (api, action) {
  yield baseFetchToken(
    api.postTicketPackage,
    action.data,
    getToken,
    InsuranceActions.postTicketPackageSuccess,
    InsuranceActions.postTicketPackageFailure
  )
}

export function * putTicketPackage (api, action) {
  yield baseFetchToken(
    api.putTicketPackage,
    action.data,
    getToken,
    InsuranceActions.putTicketPackageSuccess,
    InsuranceActions.putTicketPackageFailure
  )
}

export function * deleteTicketPackage (api, action) {
  yield baseFetchToken(
    api.deleteTicketPackage,
    action.data,
    getToken,
    InsuranceActions.deleteTicketPackageSuccess,
    InsuranceActions.deleteTicketPackageFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/InsuranceSagas.js